
export enum StyleMeterChangeType {
	Combo,
	Move,
	Penalty
}
